
import { Edit } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { getPreviewUrl } from "@/utils/imageUtils";

interface ArtworkListViewProps {
  artworks: any[];
  onArtworkClick: (artwork: any) => void;
  getArtistDisplayName: (creator: { name: string; surname: string; nick_name: string | null }) => string;
}

export const ArtworkListView = ({ artworks, onArtworkClick, getArtistDisplayName }: ArtworkListViewProps) => {
  return (
    <div className="border rounded-lg">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Title</TableHead>
            <TableHead>Creator</TableHead>
            <TableHead>Editions</TableHead>
            <TableHead>Technique</TableHead>
            <TableHead>Creation Date</TableHead>
            <TableHead>Location</TableHead>
            <TableHead>Status</TableHead>
            <TableHead className="w-[50px]">Actions</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {artworks?.map((artwork) => (
            <TableRow 
              key={artwork.artwork_id}
              className="cursor-pointer hover:bg-muted/50"
              onClick={() => onArtworkClick(artwork)}
            >
              <TableCell className="font-medium">
                {artwork.title}
              </TableCell>
              <TableCell>
                {getArtistDisplayName(artwork.creators)}
              </TableCell>
              <TableCell>
                {artwork.editions?.length || 0}
              </TableCell>
              <TableCell>{artwork.art_technique || "Not specified"}</TableCell>
              <TableCell>{artwork.creation_date || "Unknown"}</TableCell>
              <TableCell>{artwork.location || "Not specified"}</TableCell>
              <TableCell>
                <Badge
                  variant={artwork.verified ? "default" : "secondary"}
                >
                  {artwork.verified ? "Verified" : "Unverified"}
                </Badge>
              </TableCell>
              <TableCell>
                <Button 
                  variant="ghost" 
                  size="icon"
                  onClick={(e) => {
                    e.stopPropagation();
                    onArtworkClick(artwork);
                  }}
                >
                  <Edit className="h-4 w-4" />
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};
